angular.module('cvsApp').service('placeOrderService',['$rootScope', 'networkService', 'xdrService', 'configManager', 'commonModel','itemCartModel','placeOrderHelperService', 'cvsAppData', 'loggerService', 'loggerServiceHelper', function ($rootScope, NS, XS,CM, CMOD, ICM,POHS,CAD,loggerService, loggerServiceHelper) {
   	
	function placeOrderService (){
        var self = this;
        this.placeOrderResponse={};
		this.placeOrder = function(callBackSuccess){
			//get url
            /**
             * SP 12/02/2016 - ITPR015400 - Guest Refill
             * Updated logic to support login and guest flows
             */
            var tokenId, tokenType;
			// var tokenID = CAD.getTokenId();
			try{
				tokenId = CAD.getTokenId() ? CAD.getTokenId() : (guestTokenID || cvsUtility.queryMap.tokenId);
				tokenType = CAD.getTokenType() ? CAD.getTokenType() : ((guestTokenID) ? 'Guest' : 'Login');
			}
			catch(ex){
				tokenId = guestTokenID || cvsUtility.queryMap.tokenId;
				tokenType = (guestTokenID) ? 'Guest' : 'Login';
			}
			var url = CM.getAGPAPIUrl("AGP_PLACE_ORDER");
				var request = {
                    url: url,
                    header: {
                        "Content-Type": "application/json",
                        "Accept":"application/json"
                    },
                    data: getRequestBody(tokenId, tokenType),
							onSuccess:callBackSuccess
						}
			
				cvsUtility.commonServiceCode(url,"placeOrder",self,request,callBackSuccess,NS);	
            }

            // var nonClinical = {
            //     nonClinicalQuestions: {
            //         dosesLeft: {
            //             drugInfoForDosageLefts: [],
            //             userResponse:'NA'
            //         },
            //         administerMedicationChanges: {
            //             administerMedications: [],
            //             userResponse: 'NA'
            //         }
            //     }
            // }

            function formatNonClinicalQuestions(nonClinicalQues, nonClinical, rxNumbersInThisShipment) {
		        var drugInfo = {};
                if (nonClinicalQues.responseFieldIdentifier === "MEDICATION PROBLEM") {
                    nonClinical.nonClinicalQuestions.administerMedicationChanges.userResponse = nonClinicalQues.userResponse;
                }
                else if (nonClinicalQues.responseFieldIdentifier === "DOSE LEFT IND") {
                    nonClinical.nonClinicalQuestions.dosesLeft.userResponse = nonClinicalQues.userResponse;
                }
                $.each(nonClinicalQues.answerOptions, function (ansOptionIndex, answerOptionObj) {
                    if (answerOptionObj.hasOwnProperty('subQuestions')) {
                        $.each(answerOptionObj.subQuestions, function (subQuestionIndex, subQuestionObj) {
                            if(rxNumbersInThisShipment.indexOf(subQuestionObj.rxNumberHash) > -1){
                                drugInfo = {};
                                drugInfo.drugName = subQuestionObj.drugName;
                                drugInfo.drugNameEnc = subQuestionObj.drugNameEnc;
                                drugInfo.rxId = subQuestionObj.rxNumber;
                                drugInfo.rxIdEnc = subQuestionObj.rxNumberEnc;
                                if (nonClinicalQues.responseFieldIdentifier === "DOSE LEFT IND") {
                                    nonClinical.nonClinicalQuestions.dosesLeft.userResponse = nonClinicalQues.userResponse ? "yes" : 'NA';
                                    var dosageLeft = $.extend(true, {}, drugInfo)
                                    if (subQuestionObj.hasOwnProperty('question')) {
                                        $.each(subQuestionObj.question, function (questionIndex, questionObj) {
                                            if (questionObj.responseFieldIdentifier === "DOSE LEFT") {
                                                dosageLeft.numberOfDosesLeft = questionObj.answerOptions[0].answer;
                                            } else if (questionObj.responseFieldIdentifier === "NEXT DOSE") {
                                                var answerText = questionObj.answerOptions[0].answer.replaceAll('/','');
                                                dosageLeft.nextDosesDate = answerText.substring(4)+'-'+answerText.substring(0,2)+'-'+answerText.substring(2,4)
                                            }
                                        })
                                    }
                                    nonClinical.nonClinicalQuestions.dosesLeft.drugInfoForDosageLefts.push(dosageLeft);
                                } else if (nonClinicalQues.responseFieldIdentifier === "MEDICATION PROBLEM") {
                                    nonClinical.nonClinicalQuestions.administerMedicationChanges.userResponse = nonClinicalQues.userResponse ? "yes" : 'NA';
                                    var adminMedications = $.extend(true, {}, drugInfo)
                                    if (subQuestionObj.hasOwnProperty('question')) {
                                        $.each(subQuestionObj.question, function (questionIndex, questionObj) {
                                            adminMedications.additionalComments = questionObj.answerOptions[0].answerText;
                                        })
                                    }
                                    nonClinical.nonClinicalQuestions.administerMedicationChanges.administerMedications.push(adminMedications);
                                }
                            }

                        })

                    }

                });

                return nonClinical;
            }

        function generateRxQuestionsBasedOnRxs(rxDetails){

            var prescriptionQuestionsCore = ICM.getClinicalQuestions();
            var prescriptionQuestions = angular.copy(prescriptionQuestionsCore);
            // for(var index=0; index < prescriptionQuestionsCore.length; index++){
            //     prescriptionQuestions[index] = {}
            //     for(var prop in prescriptionQuestionsCore[index]){
            //         prescriptionQuestions[index][prop] =
            //             prescriptionQuestionsCore[index][prop];
            //     }
            // }

            var nonClinical;
            var nonClinicalQuestions;
            var rxNumbersInThisShipment = [];
            for(var index = 0; index < rxDetails.length; index++){
                rxNumbersInThisShipment.push(rxDetails[index].rxNumberHash);
            }
            if(Array.isArray(prescriptionQuestions) && prescriptionQuestions.length > 0){
                nonClinicalQuestions = {
                    nonClinicalQuestions: {
                        dosesLeft: {
                            drugInfoForDosageLefts: [],
                            userResponse:'NA'
                        },
                        administerMedicationChanges: {
                            administerMedications: [],
                            userResponse: 'NA'
                        }
                    }
                };

            }
            for(var index = 0; index < prescriptionQuestions.length ; index++){
                prescriptionQuestions[index].answerId = prescriptionQuestions[index].hasOwnProperty('selectedOption')? parseFloat(prescriptionQuestions[index].selectedOption) : 0;
                delete prescriptionQuestions[index].selectedOption;
                delete prescriptionQuestions[index].isOpen;
                delete prescriptionQuestions[index].isYesNo;
                delete prescriptionQuestions[index].qCount;
                delete prescriptionQuestions[index].questionLabal;
                delete prescriptionQuestions[index].templateId;
                if (prescriptionQuestions[index].responseFieldIdentifier === "DOSE LEFT IND" || prescriptionQuestions[index].responseFieldIdentifier === "MEDICATION PROBLEM") {
                   nonClinicalQuestions =
                       formatNonClinicalQuestions(prescriptionQuestions[index],
                           nonClinicalQuestions, rxNumbersInThisShipment);
                    //console.log(nonClinical);
                }
                if(prescriptionQuestions[index].hasOwnProperty('answerOptions')){
                    prescriptionQuestions[index].answerOption = prescriptionQuestions[index].answerOptions;
                    for(var ansOptionsIndex = 0; ansOptionsIndex < prescriptionQuestions[index].answerOption.length ; ansOptionsIndex++){
                        if(prescriptionQuestions[index].answerOption[ansOptionsIndex].hasOwnProperty('subQuestions')){
                            prescriptionQuestions[index].answerOption[ansOptionsIndex].subQuestion = prescriptionQuestions[index].answerOption[ansOptionsIndex].subQuestions;
                            var formattedSubQ = [];
                            for(var subQIndex = 0 ; subQIndex < prescriptionQuestions[index].answerOption[ansOptionsIndex].subQuestion.length ; subQIndex++){
                                if(prescriptionQuestions[index].answerOption[ansOptionsIndex].subQuestion[subQIndex].hasOwnProperty('question')){
                                    var formattedSubQObj = prescriptionQuestions[index].answerOption[ansOptionsIndex].subQuestion[subQIndex].question;
                                    for (var formattedSubQObjIndex = 0; formattedSubQObjIndex < formattedSubQObj.length; formattedSubQObjIndex++) {
                                        formattedSubQObj[formattedSubQObjIndex].rxNumberHash = prescriptionQuestions[index].answerOption[ansOptionsIndex].subQuestion[subQIndex].rxNumberHash;
                                        formattedSubQObj[formattedSubQObjIndex].drugName = prescriptionQuestions[index].answerOption[ansOptionsIndex].subQuestion[subQIndex].drugName;
                                    }
                                    formattedSubQ = formattedSubQ.concat(formattedSubQObj);

                                    //console.log('formattedSubQObj'+JSON.stringify(formattedSubQObj));

                                    //formattedSubQ = formattedSubQ.concat(formattedSubQObj);
                                }

                            }
                            if(formattedSubQ.length === 0){
                                formattedSubQ = prescriptionQuestions[index].answerOption[ansOptionsIndex].subQuestions;
                            }
                            // var processedSubQ = [];
                            for(var subQIndex = 0 ; subQIndex < formattedSubQ.length ; subQIndex++){
                                // console.log(formattedSubQ[subQIndex].rxNumberHash)
                                // if(((formattedSubQ[subQIndex].hasOwnProperty('rxNumberHash')
                                //         && formattedSubQ[subQIndex].rxNumberHash !== ""
                                //         && rxNumbersInThisShipment.indexOf(formattedSubQ[subQIndex].rxNumberHash) > -1)
                                //     || !formattedSubQ[subQIndex].hasOwnProperty('rxNumberHash')
                                //     || (formattedSubQ[subQIndex].hasOwnProperty('rxNumberHash')
                                //         && formattedSubQ[subQIndex].rxNumberHash === ""
                                //     )
                                // ) && 
                                if(formattedSubQ[subQIndex].hasOwnProperty('answerOptions')){
                                    formattedSubQ[subQIndex].answerOption = formattedSubQ[subQIndex].answerOptions;
                                    for(var subQAnsOptIndex = 0; subQAnsOptIndex < formattedSubQ[subQIndex].answerOptions.length; subQAnsOptIndex++){
                                        if(formattedSubQ[subQIndex].answerOption[subQAnsOptIndex].hasOwnProperty('answer')){
                                            formattedSubQ[subQIndex].answerOption[subQAnsOptIndex].answerText = formattedSubQ[subQIndex].answerOption[subQAnsOptIndex].answer;
                                            if(formattedSubQ[subQIndex].answerType === 'TEXT_DATE'){
                                                var answerText = formattedSubQ[subQIndex].answerOption[subQAnsOptIndex].answerText.replaceAll('/','');
                                                formattedSubQ[subQIndex].answerOption[subQAnsOptIndex].answerText = answerText.substring(4)+'-'+answerText.substring(0,2)+'-'+answerText.substring(2,4)
                                            }
                                            /* Append "Drug Name - " to "Quantity Remaining" and "Next Dose Date" questions/answers */
                                            if (formattedSubQ[subQIndex].responseFieldIdentifier === "DOSE LEFT" || formattedSubQ[subQIndex].responseFieldIdentifier === "NEXT DOSE") {
                                                formattedSubQ[subQIndex].answerOption[subQAnsOptIndex].answerText = formattedSubQ[subQIndex].drugName + '-' + formattedSubQ[subQIndex].answerOption[subQAnsOptIndex].answerText
                                            }
                                            delete formattedSubQ[subQIndex].answerOption[subQAnsOptIndex].answer;
                                            formattedSubQ[subQIndex].answerOption[subQAnsOptIndex].answerOptionId = 0;
                                            formattedSubQ[subQIndex].answerOption[subQAnsOptIndex].answerOptionId2 = 0;
                                            delete formattedSubQ[subQIndex].answerOption[subQAnsOptIndex].answerId;
                                        }
                                        else if(formattedSubQ[subQIndex].answerOption[subQAnsOptIndex].hasOwnProperty('subQuestions')){
                                            formattedSubQ[subQIndex].answerOption[subQAnsOptIndex].subQuestion = formattedSubQ[subQIndex].answerOption[subQAnsOptIndex].subQuestions;
                                            var formattedGrandChildSubQ = formattedSubQ[subQIndex].answerOption[subQAnsOptIndex].subQuestions;
                                            for(var grandChildSubQIndex = 0 ; grandChildSubQIndex < formattedGrandChildSubQ.length ; grandChildSubQIndex++){
                                                if(formattedGrandChildSubQ[grandChildSubQIndex].hasOwnProperty('answerOptions')){
                                                    formattedGrandChildSubQ[grandChildSubQIndex].answerOption = formattedGrandChildSubQ[grandChildSubQIndex].answerOptions;
                                                    delete formattedGrandChildSubQ[grandChildSubQIndex].answerOptions;
                                                }
                                            }
                                            delete formattedSubQ[subQIndex].answerOption[subQAnsOptIndex].subQuestions;
                                        }
                                    }

                                    delete formattedSubQ[subQIndex].questionLabal;
                                    delete formattedSubQ[subQIndex].answerOptions;
                                    delete formattedSubQ[subQIndex].drugName;

                                    // processedSubQ.push(formattedSubQ[subQIndex]);
                                } 
                                // DE27195: UI: QuestionsPage_Clinical Questions with Sub Questions UI Formatting
                                else {
                                    var answerOptionArr = [{
                                        "answerOptionId": 0,
                                        "answerText": "",
                                        "answerOptionId2": 0
                                    }];
                                    if (!formattedSubQ[subQIndex].hasOwnProperty('answerOptions')) {
                                        formattedSubQ[subQIndex].rxNumberHash = "";
                                        formattedSubQ[subQIndex].showRadio = true;
                                        formattedSubQ[subQIndex].answerOption = answerOptionArr;
                                    }
                                }


                            }
                            // if(processedSubQ.length > 0){
                            //     prescriptionQuestions[index].answerOption[ansOptionsIndex].subQuestion = processedSubQ;
                            // }
                            // else{
                            //     delete prescriptionQuestions[index].answerOption[ansOptionsIndex].subQuestion;
                            // }

                            if(formattedSubQ.length > 0){
                                prescriptionQuestions[index].answerOption[ansOptionsIndex].subQuestion = formattedSubQ;
                            }


                            delete prescriptionQuestions[index].answerOption[ansOptionsIndex].subQuestions;
                        }
                        else if(prescriptionQuestions[index].answerOption[ansOptionsIndex].hasOwnProperty('answer')){
                            prescriptionQuestions[index].answerOption[ansOptionsIndex].answerText = prescriptionQuestions[index].answerOption[ansOptionsIndex].answer;
                            if(prescriptionQuestions[index].answerType === 'TEXT_DATE'){
                                var answerText = prescriptionQuestions[index].answerOption[ansOptionsIndex].answerText.replaceAll('/', '');
                                prescriptionQuestions[index].answerOption[ansOptionsIndex].answerText = answerText.substring(4)+'-'+answerText.substring(0,2)+'-'+answerText.substring(2,4)
                            }
                            delete prescriptionQuestions[index].answerOption[ansOptionsIndex].answer;
                            prescriptionQuestions[index].answerOption[ansOptionsIndex].answerOptionId = 0;
                            prescriptionQuestions[index].answerOption[ansOptionsIndex].answerOptionId2 = 0;
                        }

                    }
                    delete prescriptionQuestions[index].answerOptions;
                }

            }

            return {"prescriptionQuestions" : prescriptionQuestions,
            "nonClinicalQuestions": nonClinicalQuestions
            };
        }

        function prepareShipmentRxsForOrder(shipmentRxs){
            var shipmentsForOrder = new Array();
            for(var i =0 ; i<shipmentRxs.length; i++){
                var obj={};

                obj.dispensingStoreDetails=shipmentRxs[i].dispensingStoreDetails;
                // obj.estimatedDeliveryDate= cvsUtility.parseDateFormat(new Date(ICM.checkOutInfo('deliveryDate')), 'yyyy-mm-dd');
                 /*
                 * US360515: UI: Refractor UI place order request object to secure Rx information Refill
                 * Removing hospitalInfo object and prescriptionNo from request
                 */
                // obj.hospitalInfo={
                //     hospitalAddress1: "",
                //     hospitalCity: "",
                //     hospitalName: "",
                //     hospitalNumber: "",
                //     hospitalStateCode: "",
                //     hospitalZipCode: ""
                // };
                /*obj.lastUpdatedTimeStamp=lastUpdatedTime;

                if(_.includes($rootScope.qArray , i)){
                    if(jQuesRes[4].data[i] && jQuesRes[4].data[i].physicianName !== undefined && jQuesRes[4].data[i].physicianName && jQuesRes[4].data[i].physicianPhone != undefined) {
                        obj.physicianChanged= 'yes';
                    obj.physicianInfo={
                        physicianName:jQuesRes[4].data[i].physicianName,
                        physicianNumber:jQuesRes[4].data[i].physicianPhone
                    }
                }else{
                        obj.physicianChanged= 'no';
                    }
                } else {
                    obj.physicianChanged= 'NA';
                }*/
                /*else{
                    obj.physicianInfo={
                        physicianName:"",
                        physicianNumber:""
                    }
                }*/

                obj.prescriptionName= shipmentRxs[i].drugName;
                obj.prescriptionNameEnc= shipmentRxs[i].drugNameEnc;
                /**
                 * SP 11/21/2016 - ITPR015400 - Guest Refill
                 * Using Encrypted Rx number
                 */
                // obj.prescriptionNo= shipmentRxs[i].rxNumber;
                obj.prescriptionNoEnc= shipmentRxs[i].rxNumberEnc ? shipmentRxs[i].rxNumberEnc : '';
                obj.prescriptionSystemName= shipmentRxs[i].prescriptionSystemName;
                obj.therapeuticCategory= shipmentRxs[i].therapeuticCategory;
                obj.firstFillIndicator =shipmentRxs[i].firstFillIndicator;
                obj.drugNdc = shipmentRxs[i].dispensedDrugNDC;
                //placeOrderInfo.prescriptionDetails.prescriptionInfo.push(obj);

                if (shipmentRxs[i].suppliesGrouped) {
                    var groupedSupply = shipmentRxs[i].suppliesGrouped;
                    var supplyObj = [];
                    for (var j = 0; j < groupedSupply.length; j++) {
                        (function (j) {
                            var groupedObj = {
                                "dispensingStoreDetails": groupedSupply[j].dispensingStoreDetails,
                            /*
                            * US360515: UI: Refractor UI place order request object to secure Rx information Refill
                            * Removing hospitalInfo object and prescriptionNo from request
                            */
                                // "hospitalInfo": {
                                //     hospitalAddress1: "",
                                //     hospitalCity: "",
                                //     hospitalName: "",
                                //     hospitalNumber: "",
                                //     hospitalStateCode: "",
                                //     hospitalZipCode: ""
                                // },
                                "prescriptionName": groupedSupply[j].drugName,
                                "prescriptionNameEnc": groupedSupply[j].drugNameEnc,
                                // "prescriptionNo": groupedSupply[j].rxNumber,
                                "prescriptionNoEnc": groupedSupply[j].rxNumberEnc ? groupedSupply[j].rxNumberEnc : '',
                                "prescriptionSystemName": groupedSupply[j].prescriptionSystemName,
                                "therapeuticCategory": groupedSupply[j].therapeuticCategory,
                                "firstFillIndicator": groupedSupply[j].firstFillIndicator,
                                "drugNdc": groupedSupply[j].dispensedDrugNDC
                            }
                            shipmentsForOrder.push(groupedObj);
                        })(j);
                    }
                }

                shipmentsForOrder.push(obj);
            }
            return shipmentsForOrder;
        }
		var getRequestBody = function(tokenId, tokenType){
            var apikey = CAD.hasOwnProperty('getApiKey') && CAD.getApiKey() ? CAD.getApiKey() : cvsUtility.queryMap.apikey;
            var checkOutInfo = ICM.checkOutInfo();
            var jQuesRes = ICM.getQuestions();
            var placeOrder =  {};
            var shipments = [];
            var placeOrderInfo = {};
            var commonParams = {};
            commonParams=POHS.extraParameter();
            // placeOrderInfo.nonClinical=POHS.nonClinicalQuestion() && POHS.nonClinicalQuestion().nonClinical;


            placeOrderInfo.orderInfo={};




            placeOrderInfo.orderInfo.prescriptionQuestions= ICM.getClinicalQuestions();
            // placeOrderInfo.orderInfo.nonClinical = nonClinical;
            setShippingDetails();
            /*setNonClinicalQuestion();
             setClinicalQuestion();*/
            setprescriptionDetails();


            // console.log(placeOrderInfo);


            function setShippingDetails(){
                placeOrderInfo.orderInfo.deliveryDetails={};
                //placeOrderInfo.orderInfo.deliveryDetails.requestedDeliveryDate = cvsUtility.parseDateFormat(new Date(ICM.checkOutInfo('deliveryDate')), 'yyyy-mm-dd');
                placeOrderInfo.orderInfo.deliveryDetails.signatureRequiredForDeliveryIndicator = ICM.checkOutInfo("checkOutInfo") && ICM.checkOutInfo("checkOutInfo").signatureRequired ? "Yes" : "No";
                placeOrderInfo.orderInfo.deliveryDetails.placeOrderAddresses = [];
                if (ICM.checkOutInfo('pickOrDel') == 'pickup') {
                    placeOrderInfo.orderInfo.deliveryDetails.deliveryType = "STORE_PICKUP";

                    placeOrderInfo.orderInfo.deliveryDetails.shipToStoreNumber=ICM.checkOutInfo('storeCheckOutInfo').storeNumber;

                    placeOrderInfo.orderInfo.deliveryDetails.placeOrderAddresses.push({"address": ICM.checkOutInfo('storeCheckOutInfo').storeAddress});

                        }
                else {
                    placeOrderInfo.orderInfo.deliveryDetails.deliveryType = "DELIVERY";
                    if(ICM.checkOutInfo('pickOrDel') == 'MDO'){
                        placeOrderInfo.orderInfo.deliveryDetails.deliveryType = "PRESCRIBER_OFFICE";
                    }
                var addressLength=ICM.checkOutInfo('checkOutInfo').address && ICM.checkOutInfo('checkOutInfo').address.length?ICM.checkOutInfo('checkOutInfo').address.length:0;
                var shippingInfo = [];
                if (addressLength > 0) {
                   for (var i = 0; i < ICM.checkOutInfo('checkOutInfo').address.length; i++) {
                        ICM.checkOutInfo('checkOutInfo').address[i].phoneNumber = "";
                        delete ICM.checkOutInfo('checkOutInfo').address[i].$$hashKey;
                       var formatShippingRequest={};
                       /*formatShippingRequest.firstName=ICM.getPatientInfo() && ICM.getPatientInfo().getPatientInfo() && ICM.getPatientInfo().getPatientInfo().firstName;
                       formatShippingRequest.lastName=ICM.getPatientInfo() && ICM.getPatientInfo().getPatientInfo() && ICM.getPatientInfo().getPatientInfo().lastName;
                       */
                            var addressChanged = ICM.checkOutInfo('checkOutInfo').address[i].addressChanged;
                            var isDeliveryAddress = ICM.checkOutInfo('checkOutInfo').address[i].isDeliveryAddress ? ICM.checkOutInfo('checkOutInfo').address[i].isDeliveryAddress : "No";
                            if (isDeliveryAddress == "YES") {
                                editedByUser = true;
                                deliveryAddressIndicator = true;
                       //formatShippingRequest.addressId=ICM.checkOutInfo('checkOutInfo').address[i].addressIdEnc?ICM.checkOutInfo('checkOutInfo').address[i].addressIdEnc:"";
                       formatShippingRequest.addressId=ICM.checkOutInfo('checkOutInfo').address[i].addressIdEnc?ICM.checkOutInfo('checkOutInfo').address[i].addressIdEnc:(ICM.checkOutInfo('checkOutInfo').address[i].addressId? ICM.checkOutInfo('checkOutInfo').address[i].addressId: "");
                           formatShippingRequest.addressLine1=ICM.checkOutInfo('checkOutInfo').address[i].addressLine1?ICM.checkOutInfo('checkOutInfo').address[i].addressLine1:"";
                           formatShippingRequest.addressLine2=ICM.checkOutInfo('checkOutInfo').address[i].addressLine2?ICM.checkOutInfo('checkOutInfo').address[i].addressLine2:"";
                           formatShippingRequest.city=ICM.checkOutInfo('checkOutInfo').address[i].city?ICM.checkOutInfo('checkOutInfo').address[i].city:"";
                                formatShippingRequest.state = ICM.checkOutInfo('checkOutInfo').address[i].state ? ICM.checkOutInfo('checkOutInfo').address[i].state : "";
                           formatShippingRequest.zipCode=ICM.checkOutInfo('checkOutInfo').address[i].zipCode?ICM.checkOutInfo('checkOutInfo').address[i].zipCode:"";
                           // formatShippingRequest.phoneNumber=ICM.checkOutInfo('checkOutInfo').address[i].phoneNumber?ICM.checkOutInfo('checkOutInfo').address[i].phoneNumber:"";
                       /**
                        * SP 12/27/2016
                        * Added logic to send encrypted address details
                        * @type {string}
                        */
                       formatShippingRequest.addressLine1Enc=ICM.checkOutInfo('checkOutInfo').address[i].addressLine1Enc?ICM.checkOutInfo('checkOutInfo').address[i].addressLine1Enc:"";
                       formatShippingRequest.addressLine2Enc=ICM.checkOutInfo('checkOutInfo').address[i].addressLine2Enc?ICM.checkOutInfo('checkOutInfo').address[i].addressLine2Enc:"";
                       formatShippingRequest.cityEnc=ICM.checkOutInfo('checkOutInfo').address[i].cityEnc?ICM.checkOutInfo('checkOutInfo').address[i].cityEnc:"";
                       formatShippingRequest.zipCodeEnc=ICM.checkOutInfo('checkOutInfo').address[i].zipCodeEnc?ICM.checkOutInfo('checkOutInfo').address[i].zipCodeEnc:"";
                       addressChanged = undefined ? "No": "YES";
                                shippingInfo = {
                                    "editedByUser": addressChanged.toUpperCase() === "YES" ? true: false,
                                    "deliveryAddressIndicator": true,
                                    "address": formatShippingRequest
                                };
                    }
                        }
                }else if(ICM.checkOutInfo('checkOutInfo').address){
                    ICM.checkOutInfo('checkOutInfo').address.phoneNumber = "";
                    delete ICM.checkOutInfo('checkOutInfo').address.$$hashKey;
                    var formatShippingRequest={};
                    if(ICM.checkOutInfo('checkOutInfo') && ICM.checkOutInfo('checkOutInfo').address && ICM.checkOutInfo('checkOutInfo').address.firstName){
                        formatShippingRequest.firstName=ICM.checkOutInfo('checkOutInfo').address.firstName;
                    }
                    if(ICM.checkOutInfo('checkOutInfo') && ICM.checkOutInfo('checkOutInfo').address && ICM.checkOutInfo('checkOutInfo').address.lastName){
                        formatShippingRequest.lastName=ICM.checkOutInfo('checkOutInfo').address.lastName;
                    }
                    /*formatShippingRequest.firstName=ICM.getPatientInfo() && ICM.getPatientInfo().getPatientInfo() && ICM.getPatientInfo().getPatientInfo().firstName;
                    formatShippingRequest.lastName=ICM.getPatientInfo() && ICM.getPatientInfo().getPatientInfo() && ICM.getPatientInfo().getPatientInfo().lastName;*/
                        //formatShippingRequest.addressChanged = ICM.checkOutInfo('checkOutInfo').address.addressChanged ? ICM.checkOutInfo('checkOutInfo').address.addressChanged : "No";
                        var isDeliveryAddress = ICM.checkOutInfo('checkOutInfo').address.isDeliveryAddress ? ICM.checkOutInfo('checkOutInfo').address.isDeliveryAddress : "No";
                        var addressChanged = ICM.checkOutInfo('checkOutInfo').address.addressChanged;
                        if (isDeliveryAddress == "YES") {
                    formatShippingRequest.addressId=ICM.checkOutInfo('checkOutInfo').address.addressIdEnc?ICM.checkOutInfo('checkOutInfo').address.addressIdEnc:(ICM.checkOutInfo('checkOutInfo').address.addressId? ICM.checkOutInfo('checkOutInfo').address.addressId: "");
                    formatShippingRequest.addressLine1=ICM.checkOutInfo('checkOutInfo').address.addressLine1?ICM.checkOutInfo('checkOutInfo').address.addressLine1:"";
                    formatShippingRequest.addressLine2=ICM.checkOutInfo('checkOutInfo').address.addressLine2?ICM.checkOutInfo('checkOutInfo').address.addressLine2:"";
                    formatShippingRequest.city=ICM.checkOutInfo('checkOutInfo').address.city?ICM.checkOutInfo('checkOutInfo').address.city:"";
                            formatShippingRequest.state = ICM.checkOutInfo('checkOutInfo').address.state ? ICM.checkOutInfo('checkOutInfo').address.state : "";
                    formatShippingRequest.zipCode=ICM.checkOutInfo('checkOutInfo').address.zipCode?ICM.checkOutInfo('checkOutInfo').address.zipCode:"";
                    // formatShippingRequest.phoneNumber=ICM.checkOutInfo('checkOutInfo').address.phoneNumber?ICM.checkOutInfo('checkOutInfo').address.phoneNumber:"";
                    /**
                     * SP 12/27/2016
                     * Added logic to send encrypted address details
                     * @type {string}
                     */
                    formatShippingRequest.addressLine1Enc=ICM.checkOutInfo('checkOutInfo').address.addressLine1Enc?ICM.checkOutInfo('checkOutInfo').address.addressLine1Enc:"";
                    formatShippingRequest.addressLine2Enc=ICM.checkOutInfo('checkOutInfo').address.addressLine2Enc?ICM.checkOutInfo('checkOutInfo').address.addressLine2Enc:"";
                    formatShippingRequest.cityEnc=ICM.checkOutInfo('checkOutInfo').address.cityEnc?ICM.checkOutInfo('checkOutInfo').address.cityEnc:"";
                    formatShippingRequest.zipCodeEnc=ICM.checkOutInfo('checkOutInfo').address.zipCodeEnc?ICM.checkOutInfo('checkOutInfo').address.zipCodeEnc:"";
                    addressChanged = undefined ? "No": "YES";                    
                            shippingInfo = {
                                "editedByUser": addressChanged.toUpperCase() === "YES" ? true: false,
                                "deliveryAddressIndicator": true,
                                "address": formatShippingRequest
                    };
                }
                    }
                    placeOrderInfo.orderInfo.deliveryDetails.placeOrderAddresses.push(shippingInfo);
                }

            }

        	function setNonClinicalQuestion(){
          		
                if(_.isEmpty(jQuesRes)){
                    return;
                }
        		placeOrderInfo.nonClinical ={};
        		var nonClinicalQuestions = placeOrderInfo.nonClinical.nonClinicalQuestions={};
        		nonClinicalQuestions.allergies ={
            		additionalComments:jQuesRes[0].data.answerText || "",
            		userResponse:jQuesRes[0].answer
        		}

        		nonClinicalQuestions.insuranceChanged={
                    insuranceInfo:{
                    	cardHolderDOB: jQuesRes[1].data.dateOfBirth,
    					cardHolderName: jQuesRes[1].data.subscriberName,
    					effectiveDate: jQuesRes[1].data.effectiveDate,
    					employerName: jQuesRes[1].data.employerName,
    					groupNumber: jQuesRes[1].data.groupNumber,
    					idNumber: jQuesRes[1].data.idNumber,
    					newInsCompName: jQuesRes[1].data.insuranceName,
    					newInsPhoneNo: jQuesRes[1].data.insurancePhone,
    					relationshipToCardHolder: jQuesRes[1].data.relationship,
    					rxBIN: jQuesRes[1].data.bin,
    					rxPCN: jQuesRes[1].data.pcn
                    },
                    userResponse:jQuesRes[1].answer
    		    };

        		nonClinicalQuestions.dosageChanged={
                    drugInfoForDosageChange:[],
                userResponse:jQuesRes[2].answer != undefined ? jQuesRes[2].answer : 'NA'                    
        		}
                for(var i=0;i<jQuesRes[2].data.length;i++){

					if(jQuesRes[2].data[i].newdosage != undefined && jQuesRes[2].data[i].frequency != undefined) {
                	var obj={
                		drugName:jQuesRes[2].data[i].drugName,
                        drugName:jQuesRes[2].data[i].drugNameEnc,
                        rxId:jQuesRes[2].data[i].rxId,
                		newDosage:jQuesRes[2].data[i].newdosage,
                		newFrequency:jQuesRes[2].data[i].frequency
                	};
                    nonClinicalQuestions.dosageChanged.drugInfoForDosageChange.push(obj);
                }

                }

        		nonClinicalQuestions.dosesLeft={
                userResponse:jQuesRes[3].answer != undefined ? jQuesRes[3].answer : 'NA'
        		}

    		    for(var i=0;i<jQuesRes[3].data.length;i++){
                	var obj={
                		drugName:jQuesRes[3].data[i].drugName,
                        drugNameEnc:jQuesRes[3].data[i].drugNameEnc,
                        rxId:jQuesRes[3].data[i].rxId,
                		nextDosesDate:jQuesRes[3].data[i].nextDogeDate,
                		numberOfDosesLeft:jQuesRes[3].data[i].dosageLeft
                	};
				if(jQuesRes[3].data[i].drugName != undefined)
				{
					if(nonClinicalQuestions.dosesLeft.drugInfoForDosageLeft == undefined) {
						nonClinicalQuestions.dosesLeft.drugInfoForDosageLeft = [];
					}
                nonClinicalQuestions.dosesLeft.drugInfoForDosageLeft.push(obj);
				}

                }

        		nonClinicalQuestions.physicianInfoChanges={
                    physicianInfo:[],
                userResponse:jQuesRes[4].answer != undefined ? jQuesRes[4].answer : 'NA'
        		}
    		    for(var i=0;i<jQuesRes[4].data.length;i++){
                	var obj={
                		drugName:jQuesRes[4].data[i].drugName,
                        drugNameEnc:jQuesRes[4].data[i].drugNameEnc,
                        rxId:jQuesRes[4].data[i].rxId,
                		physicianName:jQuesRes[4].data[i].physicianName,
                		physicianNumber:jQuesRes[4].data[i].physicianPhone
                	};
				if(obj.physicianNumber !== undefined && obj.physicianName !== undefined) {
                    nonClinicalQuestions.physicianInfoChanges.physicianInfo.push(obj);
				}

                }

                nonClinicalQuestions.administerMedicationChanges={
                    administerMedication:[],
                userResponse:jQuesRes[5].answer!= undefined ? jQuesRes[5].answer : 'NA'
        		}
        		for(var i=0;i<jQuesRes[5].data.length;i++){
				if(jQuesRes[5].data[i].answerText !== undefined && jQuesRes[5].data[i].answerText.length > 0) {
                	var obj={
                		drugName:jQuesRes[5].data[i].drugName,
                        drugNameEnc:jQuesRes[5].data[i].drugNameEnc,
                        rxId:jQuesRes[5].data[i].rxId,
                		additionalComments:jQuesRes[5].data[i].answerText
                	};
                    nonClinicalQuestions.administerMedicationChanges.administerMedication.push(obj);
				}

                }    
   		   };

        	function setprescriptionDetails(){
        		var refillPres = ICM.getCartItems();
        		//var c = cvsUtility.xmlToJSON("<prescriptionDetails><prescriptionInfo><prescriptionNo>100223150</prescriptionNo><prescriptionName>Enbrel Sureclick 50Mg/Ml Soln</prescriptionName><lastUpdatedTimeStamp>2010-12-11 12:59:59:AM</lastUpdatedTimeStamp><estimatedDeliveryDate>2010-03-15</estimatedDeliveryDate><physicianChanged>Yes</physicianChanged><physicianInfo><physicianName>Dr.John</physicianName><physicianNumber>A123456</physicianNumber></physicianInfo><hospitalInfo><hospitalName>NORTHCENTER</hospitalName><hospitalNumber>W122322</hospitalNumber><hospitalAddress1>N MAIN STREET</hospitalAddress1><hospitalCity>CHICAGO</hospitalCity><hospitalStateCode>IL</hospitalStateCode><hospitalZipCode>78453</hospitalZipCode></hospitalInfo><dispensingStoreDetails><dispensingStoreNumber>48045</dispensingStoreNumber><dispensingStoreNPINumber>1124009121</dispensingStoreNPINumber><dispensingStorePharmacyName>CAREMARK NORTH CAROLINA PHARMACY, L.L.C.</dispensingStorePharmacyName><dispensingStoreType>Specialty Pharmacy</dispensingStoreType></dispensingStoreDetails></prescriptionInfo><prescriptionInfo><prescriptionNo>100395236</prescriptionNo><prescriptionName>Enbrel Sureclick 50Mg/Ml Soln</prescriptionName><lastUpdatedTimeStamp>2010-02-01 11:25:55:AM</lastUpdatedTimeStamp><estimatedDeliveryDate>2010-12-15</estimatedDeliveryDate><physicianChanged>No</physicianChanged><physicianInfo><physicianName>Dr.John</physicianName><physicianNumber>A123456</physicianNumber></physicianInfo><hospitalInfo><hospitalName>NORTHCENTER</hospitalName><hospitalNumber>W122322</hospitalNumber><hospitalAddress1>N MAIN STREET</hospitalAddress1><hospitalCity>CHICAGO</hospitalCity><hospitalStateCode>IL</hospitalStateCode><hospitalZipCode>78453</hospitalZipCode></hospitalInfo><dispensingStoreDetails><dispensingStoreNumber>48045</dispensingStoreNumber><dispensingStoreNPINumber>1124009121</dispensingStoreNPINumber><dispensingStorePharmacyName>CAREMARK NORTH CAROLINA PHARMACY, L.L.C.</dispensingStorePharmacyName><dispensingStoreType>Specialty Pharmacy</dispensingStoreType></dispensingStoreDetails></prescriptionInfo></prescriptionDetails>");
        		// console.log(c);
        		// console.log(refillPres);
                //placeOrderInfo.prescriptionDetails={};
        		//placeOrderInfo.prescriptionDetails.prescriptionInfo=[];
               // placeOrderInfo.orderInfos={};
                shipments.rxInfos = [];
                for(var i =0 ; i<refillPres.length; i++){
                    var obj={};
                    //var lastUpdatedTime = cvsUtility.parseDateFormat(new Date(), 'yyyy-mm-dd h:m:s', '-', ':', true, ':');
                    var date = new Date();
                    function convertToTwoDigit (number) {
                        return (number < 10) ? '0' + number : number;
                    }

                    var currentYear = date.getFullYear();
                    var currentMonth =convertToTwoDigit(date.getMonth() + 1);
                    var currentDay = convertToTwoDigit(date.getDate());

                    var hour = convertToTwoDigit(date.getHours());
                    var minute = convertToTwoDigit(date.getMinutes());
                    var second = convertToTwoDigit(date.getSeconds());
                    var amOrPm=hour >= 12 ? 'PM' : 'AM';
                    hour=hour > 12 ? hour - 12: hour;
                    hour=convertToTwoDigit(hour);

                    var lastUpdatedTime = currentYear + '-' + currentMonth + '-' + currentDay + 'T' + hour + ':' + minute + ':' + second;
                    lastUpdatedTime += ":" + amOrPm;
                    obj.dispensingStoreDetails=refillPres[i].dispensingStoreDetails;
                    // obj.estimatedDeliveryDate= cvsUtility.parseDateFormat(new Date(ICM.checkOutInfo('deliveryDate')), 'yyyy-mm-dd');
                    /*
                     * US360515: UI: Refractor UI place order request object to secure Rx information Refill
                     * Removing hospitalInfo object and prescriptionNo from request
                     */
                    // obj.hospitalInfo={
                    //     hospitalAddress1: "",
                    //     hospitalCity: "",
                    //     hospitalName: "",
                    //     hospitalNumber: "",
                    //     hospitalStateCode: "",
                    //     hospitalZipCode: ""
                    // };
                    /*obj.lastUpdatedTimeStamp=lastUpdatedTime;
                    
                    if(_.includes($rootScope.qArray , i)){
						if(jQuesRes[4].data[i] && jQuesRes[4].data[i].physicianName !== undefined && jQuesRes[4].data[i].physicianName && jQuesRes[4].data[i].physicianPhone != undefined) {
							obj.physicianChanged= 'yes';
                        obj.physicianInfo={                            
                            physicianName:jQuesRes[4].data[i].physicianName,
                            physicianNumber:jQuesRes[4].data[i].physicianPhone
                        }
                    }else{
							obj.physicianChanged= 'no';
						}
                    } else {
						obj.physicianChanged= 'NA';
                    }*/
					/*else{
                        obj.physicianInfo={                            
                            physicianName:"",
                            physicianNumber:""
                        }
    				}*/
                   
                    obj.prescriptionName= refillPres[i].drugName;
                    obj.prescriptionNameEnc= refillPres[i].drugNameEnc;
                    /**
                     * SP 11/21/2016 - ITPR015400 - Guest Refill
                     * Using Encrypted Rx number
                     */
                    // obj.prescriptionNo= refillPres[i].rxNumber;
                    obj.prescriptionNoEnc= refillPres[i].rxNumberEnc ? refillPres[i].rxNumberEnc : '';
                    obj.prescriptionSystemName= refillPres[i].prescriptionSystemName;
                    obj.therapeuticCategory= refillPres[i].therapeuticCategory;
                    obj.firstFillIndicator =refillPres[i].firstFillIndicator;
                    obj.drugNdc = refillPres[i].dispensedDrugNDC;
                    //placeOrderInfo.prescriptionDetails.prescriptionInfo.push(obj);

                    if (refillPres[i].suppliesGrouped) {
                        var groupedSupply = refillPres[i].suppliesGrouped;
                        var supplyObj = [];
                        for (var j = 0; j < groupedSupply.length; j++) {
                            (function (j) {
                                var groupedObj = {
                                    "dispensingStoreDetails": groupedSupply[j].dispensingStoreDetails,
                                    /*
                                    * US360515: UI: Refractor UI place order request object to secure Rx information Refill
                                    * Removing hospitalInfo object from request
                                    */
                                    // "hospitalInfo": {
                                    //     hospitalAddress1: "",
                                    //     hospitalCity: "",
                                    //     hospitalName: "",
                                    //     hospitalNumber: "",
                                    //     hospitalStateCode: "",
                                    //     hospitalZipCode: ""
                                    // },
                                    "prescriptionName": groupedSupply[j].drugName,
                                    "prescriptionNameEnc": groupedSupply[j].drugNameEnc,
                                    // "prescriptionNo": groupedSupply[j].rxNumber,
                                    "prescriptionNoEnc": groupedSupply[j].rxNumberEnc ? groupedSupply[j].rxNumberEnc : '',
                                    "prescriptionSystemName": groupedSupply[j].prescriptionSystemName,
                                    "therapeuticCategory": groupedSupply[j].therapeuticCategory,
                                    "firstFillIndicator": groupedSupply[j].firstFillIndicator,
                                    "drugNdc": groupedSupply[j].dispensedDrugNDC
                                }
                                shipments.rxInfos.push(groupedObj);
                            })(j);
                        }
                    }

                    shipments.rxInfos.push(obj);
        	   }
            };



            function setClinicalQuestion(){
                // var b = cvsUtility.xmlToJSON("<clinical><clinicalQuestions><clinicalQuestion><questionId>1</questionId><questionText>What is your gender?</questionText><answerType>SINGLE_SELECT</answerType><userResponse>Female</userResponse><answerOptions><answerOption><answerOptionID>2</answerOptionID><answerId>1</answerId><answerText>Male</answerText><subquestions><subQuestion><questionId/><questionText/><answerType/><userResponse/><answerOptions/></subQuestion></subquestions></answerOption><answerOption><answerOptionID>3</answerOptionID><answerId>2</answerId><answerText>Female</answerText><subquestions><subQuestion><questionId>4</questionId><questionText>Are you pregnant?</questionText><answerType>SINGLE_SELECT</answerType><userResponse>YES</userResponse><answerOptions><answerOption><answerOptionID>5</answerOptionID><answerId>3</answerId><answerText>YES</answerText><subquestions><subQuestion><questionId>7</questionId><questionText>What is your trimester?</questionText><answerType>SINGLE_SELECT</answerType><userResponse>1</userResponse><answerOptions><answerOption><answerOptionID>8</answerOptionID><answerId>5</answerId><answerText>1</answerText><subquestions><subQuestion><questionId>11</questionId><questionText>Are you taking adequate rest?</questionText><answerType>SINGLE_SELECT</answerType><userResponse>YES</userResponse><answerOptions><answerOption><answerOptionID>6</answerOptionID><answerId>9</answerId><answerText>No</answerText><subquestions><subQuestion><questionId/><questionText/><answerType/><userResponse/><answerOptions/></subQuestion></subquestions></answerOption><answerOption><answerOptionID>5</answerOptionID><answerId>8</answerId><answerText>YES</answerText><subquestions><subQuestion><questionId/><questionText/><answerType/><userResponse/><answerOptions/></subQuestion></subquestions></answerOption></answerOptions></subQuestion></subquestions></answerOption><answerOption><answerOptionID>9</answerOptionID><answerId>6</answerId><answerText>2</answerText><subquestions><subQuestion><questionId/><questionText/><answerType/><userResponse/><answerOptions/></subQuestion></subquestions></answerOption><answerOption><answerOptionID>10</answerOptionID><answerId>7</answerId><answerText>3</answerText><subquestions><subQuestion><questionId/><questionText/><answerType/><userResponse/><answerOptions/></subQuestion></subquestions></answerOption></answerOptions></subQuestion></subquestions></answerOption><answerOption><answerOptionID>6</answerOptionID><answerId>4</answerId><answerText>No</answerText><subquestions><subQuestion><questionId/><questionText/><answerType/><userResponse/><answerOptions/></subQuestion></subquestions></answerOption></answerOptions></subQuestion></subquestions></answerOption></answerOptions></clinicalQuestion><clinicalQuestion><questionId>12</questionId><questionText>Do you posess any tablet? If so, please enter the number?</questionText><answerType>TEXT</answerType><userResponse>20</userResponse><answerOptions><answerOption><answerOptionID/><answerId>10</answerId><answerText/><subquestions><subQuestion><questionId/><questionText/><answerType/><userResponse/><answerOptions/></subQuestion></subquestions></answerOption></answerOptions></clinicalQuestion><clinicalQuestion><questionId>13</questionId><questionText>What is your age?</questionText><answerType>TEXT_NUMBER</answerType><userResponse>30</userResponse><answerOptions><answerOption><answerOptionID/><answerId>11</answerId><answerText/><subquestions><subQuestion><questionId/><questionText/><answerType/><userResponse/><answerOptions/></subQuestion></subquestions></answerOption></answerOptions></clinicalQuestion><clinicalQuestion><questionId>14</questionId><questionText>What is your date of birth?</questionText><answerType>TEXT_DATE</answerType><userResponse>01/01/1985</userResponse><answerOptions><answerOption><answerOptionID/><answerId>12</answerId><answerText/><subquestions><subQuestion><questionId/><questionText/><answerType/><userResponse/><answerOptions/></subQuestion></subquestions></answerOption></answerOptions></clinicalQuestion><clinicalQuestion><questionId>15</questionId><questionText>Select the medications which you are taking</questionText><answerType>MULTI_SELECT</answerType><userResponse>Ibuprofen / Pain Killers,Zyretec / Anti allergies,Steroids</userResponse><answerOptions><answerOption><answerOptionID>16</answerOptionID><answerId>13</answerId><answerText>Ibuprofen / Pain Killers</answerText><subquestions><subQuestion><questionId/><questionText/><answerType/><userResponse/><answerOptions/></subQuestion></subquestions></answerOption><answerOption><answerOptionID>17</answerOptionID><answerId>14</answerId><answerText>Zyretec / Anti allergies</answerText><subquestions><subQuestion><questionId/><questionText/><answerType/><userResponse/><answerOptions/></subQuestion></subquestions></answerOption><answerOption><answerOptionID>18</answerOptionID><answerId>15</answerId><answerText>Steroids</answerText><subquestions><subQuestion><questionId/><questionText/><answerType/><userResponse/><answerOptions/></subQuestion></subquestions></answerOption></answerOptions></clinicalQuestion></clinicalQuestions></clinical>");
                var jQuesRes = ICM.getClinicalQuestions();
                // console.log(b);
                //console.log(jQuesRes);
                placeOrderInfo.clinical={};
                var clinicalQuestions = placeOrderInfo.clinical.clinicalQuestions={};
                clinicalQuestions.clinicalQuestion=[];
                for( var i =0 ; i<jQuesRes.length; i++){
                    var freshObj ={};
                    freshObj.answerOptions={};
                    if(jQuesRes[i].answerType=="SINGLE_SELECT"){
                        freshObj.answerOptions.answerOption=[];
                        freshObj.answerType = jQuesRes[i].answerType;
                        freshObj.questionId = jQuesRes[i].questionId;
                        freshObj.questionText=jQuesRes[i].questionText;
                        freshObj.userResponse= jQuesRes[i].userResponse;
                        freshObj.answerId= jQuesRes[i].selectedOption;
                        recurse(jQuesRes[i].answerOption,freshObj.answerOptions.answerOption);


                        function recurse(newData,insertArray){
                            for(var j =0 ; j<newData.length;j++){
                                var obj={};
                                obj.answerId=newData[j].answerId;
                                obj.answerOptionID=newData[j].answerOptionId;
                                obj.answerText=newData[j].answerText || newData[j].answer;
                                obj.subquestions={};
                                if(_.isEmpty(newData[j].subQuestion)){
                                    obj.subquestions.subQuestion={
                                        answerOptions: "",
                                        answerType: "",
                                        questionId: "",
                                        questionText: "",
                                        userResponse: ""
                                    }
                                    insertArray.push(obj);
                                }else{
                                    obj.subquestions.subQuestion={
                                        answerType: newData[j].subQuestion[0].answerType,
                                        questionId: newData[j].subQuestion[0].questionId,
                                        questionText: newData[j].subQuestion[0].questionText,
                                        userResponse: newData[j].subQuestion[0].userResponse || newData[j].subQuestion[0].answerOption[0].answer,
                                        answerOptions:{
                                            answerOption:[]
                                        }
                                    }
                                    insertArray.push(obj);
                                    recurse(newData[j].subQuestion[0].answerOption,obj.subquestions.subQuestion.answerOptions.answerOption)
                                }
                            }
                        }

		    	     } else if(jQuesRes[i].answerType=="MULTI_SELECT"){
                        var str =" ";
                        var answerArray =[];
                        freshObj.answerOptions.answerOption=[];
                        var answerOption = freshObj.answerOptions.answerOption;	
                        for(var j = 0; j<jQuesRes[i].answerOption.length;j++){
                            var obj= {};
                            obj.subquestions={};
                            obj.subquestions.subquestion={
                                answerOptions: "",
                                answerType: "",
                                questionId: "",
                                questionText: "",
                                userResponse: "",
                            }
                            obj.answerId=jQuesRes[i].answerOption[j].answerId;
                            obj.answerOptionID=jQuesRes[i].answerOption[j].answerOptionId;
                            obj.answerText=jQuesRes[i].answerOption[j].answerText;

                            if(jQuesRes[i].answerOption[j].hasOwnProperty('isChecked')){
                                str = str +"/"+jQuesRes[i].answerOption[j].answerText
                                str = str.replace(" /","");
                                freshObj.userResponse =str;
                                answerArray.push(obj.answerOptionID);
                            }
                            answerOption.push(obj);
                        }
                        freshObj.answerId=answerArray;
                        freshObj.answerType= jQuesRes[i].answerType;
                        freshObj.questionId= jQuesRes[i].questionId;
                        freshObj.questionText= jQuesRes[i].questionText;
                    }else{
                        var answerOption = freshObj.answerOptions.answerOption={};
                        answerOption.answerId=jQuesRes[i].answerOption[0].answerId;
                        answerOption.answerOptionId="";
                        answerOption.answerText="";
                        answerOption.subquestions={};
                        answerOption.subquestions.subquestion={
                            answerOptions: "",
                            answerType: "",
                            questionId: "",
                            questionText: "",
                            userResponse: "",
                        }
                        freshObj.answerType= jQuesRes[i].answerType;
                        freshObj.questionId= jQuesRes[i].questionId;
                        freshObj.questionText= jQuesRes[i].questionText;
                        freshObj.userResponse =jQuesRes[i].answerOption[0].answer;
                        freshObj.answerId=jQuesRes[i].answerOption[0].answerId;

                    }
                    clinicalQuestions.clinicalQuestion.push(freshObj);
                }
            };

            if(ICM.checkOutInfo("patientContact")){
                placeOrderInfo.patientContact=POHS.patientContact();
            }
            
            var log = loggerService(loggerServiceHelper.setCategory(CVSLOGHELPER.CATEGORY.Refill));
            try{

                if (log && log.debug) {
                    log.debug(loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.ReviewRefills) + loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) +
                        loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallStart) + loggerServiceHelper.setDescription("Calling PlaceOrder - Non-Clinical questions count: " +
                            Object.keys(placeOrderInfo.nonClinical.nonClinicalQuestions).length +" -- Clinical questions count: "+ (placeOrderInfo.clinical.clinicalQuestions.hasOwnProperty('clinicalQuestion') && Array.isArray(placeOrderInfo.clinical.clinicalQuestions.clinicalQuestion) ? placeOrderInfo.clinical.clinicalQuestions.clinicalQuestion.length:0 )+
                        " -- Shipping method: "+ (placeOrderInfo.hasOwnProperty('storePickupDetails')? 'pickup' : 'shipping')+
                        " -- Needs by: "+ placeOrderInfo.needsByDate));
                }
            }
            catch(ex){
                if (log && log.error) {
                    log.error(loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.ReviewRefills) + loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) +
                        loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallStart) + loggerServiceHelper.setDescription("PlaceOrder service req logging error "));
                }
            }
            //console.log(cvsUtility.JSONToXml({"placeOrderInfo":placeOrderInfo}));

            function prepareShipmentsForOrder(){
                var shipmentsSourceArray = ICM.getSmartGrouper();
                var shipmentsProcessed = [];

                var log = loggerService(loggerServiceHelper.setCategory(CVSLOGHELPER.CATEGORY.Refill));
                try {

                    if (log && log.debug) {
                        log.debug(loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.ReviewRefills) + loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) +
                        loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallStart) + loggerServiceHelper.setDescription("Calling PlaceOrder - Shipment count: " +
                        (Object.keys(shipmentsSourceArray).length)));
                    }
                }
                catch (ex) {
                    if (log && log.error) {
                        log.error(loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.ReviewRefills) + loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) +
                        loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallStart) + loggerServiceHelper.setDescription("PlaceOrder service req logging error "));
                    }
                }

                for(var index = 0; index < shipmentsSourceArray.length; index++){

                    var generatedRxQuestions =
                        generateRxQuestionsBasedOnRxs(shipmentsSourceArray[index].rxDetails);
                    var shipmentReqObj= angular.copy({
                        "groupIndex": shipmentsSourceArray[index].groupIndex,
                        "rxInfos": prepareShipmentRxsForOrder(shipmentsSourceArray[index].rxDetails),
                        "nonClinical": generatedRxQuestions.nonClinicalQuestions,
                        "prescriptionQuestions":
                        generatedRxQuestions.prescriptionQuestions,
                        "deliveryDetails": placeOrderInfo.orderInfo.deliveryDetails
                    })

                    shipmentReqObj.deliveryDetails.requestedDeliveryDate =
                        cvsUtility.parseDateFormat(new Date(shipmentsSourceArray[index].deliveryDate), 'yyyy-mm-dd');
                    shipmentsProcessed.push(shipmentReqObj);
                    shipmentReqObj = null;
                }

                return shipmentsProcessed;


            }
            // console.log(ICM.getSmartGrouper());
    		return {
                "placeOrderRequest": {
                    "header": {
                        "serviceContext": {
                            "appName": cvsUtility.queryMap.mobileAppStyle ? 'SPL_APP' : 'SPL_WEB',
                            "lineOfBusiness": "Specialty",
                            "channelName": cvsUtility.queryMap.channel,
                            "responseFormat": "JSON",
                            "tokenID" : tokenId,
                            "tokenType": CM.getAGPTokenType(tokenType)
                        },
                        "securityContext": {
                            "apiKey": apikey,
                            "securityType": "apiKey"
                        }
                    },
                    "details": {
                        "commonParams": commonParams,
                        "shipments": prepareShipmentsForOrder()
                    }
                }
            }
    	}
		

		this.setResponse = function(data){
            //data = data.replace(/[\n\r\t]+/g,"");
            this.placeOrderResponse = data.placeOrderResponse;
			//CMOD.setResponse(data);
		};

		this.getResponse = function(){
            /**
             * sankar 11/22/2016 - ITPR017031 - confirm Refill
             * returned the response data for getting the orderid and purchaseid, earlier only true or false was returned
             */
            if(this.placeOrderResponse && this.placeOrderResponse.hasOwnProperty("processRxOrdersResponse") && this.placeOrderResponse.processRxOrdersResponse.status && this.placeOrderResponse.processRxOrdersResponse.status.statusCode && this.placeOrderResponse.processRxOrdersResponse.status.statusCode==="DBPL0000"){
                return this.placeOrderResponse;
            }
            else if(this.placeOrderResponse && this.placeOrderResponse.hasOwnProperty("response") && this.placeOrderResponse.response && this.placeOrderResponse.response.header && this.placeOrderResponse.response.header.statusCode &&  this.placeOrderResponse.response.header.statusCode == "DBPL0000"){
                return this.placeOrderResponse;
            }
            else if(this.placeOrderResponse && this.placeOrderResponse.hasOwnProperty("header") && this.placeOrderResponse.header && this.placeOrderResponse.header.statusCode &&  (this.placeOrderResponse.header.statusCode == "0000" || this.placeOrderResponse.header.statusCode == "1009")){
                return this.placeOrderResponse;
            }

			else{
                //return false;
                this.placeOrderResponse.SERVER_ERROR = true;
                return this.placeOrderResponse;
            }
		}

	};

	return new placeOrderService();	
}]);